import { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { TrashIcon } from '@heroicons/react/24/outline'
import { GetWorkoutTemplateNameFromKey } from 'functions/textUtils';
import { setActiveWeekCompletionData } from 'redux/slices/athleteProfile'
import kinesisLogo from 'media/kinesis_logo.png'

import GroupCompletionLinearFill from 'components/Athlete/v2/AthleteCalendar/AthleteCalendarEventItems/GroupCompletionLinearFill'

export default function ActiveKinesisWorkoutCalendarEventItem({ eventData }) {
    const dispatch = useDispatch()

    const { ShowModal } = useContext(ModalContext)

    const profileType = useSelector((state) => state.athleteProfile.profileType)
    const trainingChartPresentWeekOfTheYearKey = useSelector((state) => state.athleteProfile.trainingChartPresentWeekOfTheYearKey)

    const OnEventItemClicked = () => {

        // TOOD: Fix this!!

        if (profileType === 'group') {
            ShowWorkoutOverrideModal()
        }

        if (profileType === 'group-individual' || profileType === 'individual') {

            if (eventData.extendedProps.completionData.completed === true) DisplayWorkoutSummaryModal()

            if (eventData.extendedProps.completionData.completed === false) ShowWorkoutOverrideModal()

        }

    }

    const DisplayWorkoutSummaryModal = () => {

        // console.log(eventData.extendedProps)

        const modalData = {
            key: ModalKey.WorkoutSummary,
            size: 'workout-summary',
            calendarDataKey: eventData.extendedProps.calendarDataKey,
            weekOfTheYearKey: eventData.extendedProps.weekOfTheYearKey,
            workoutTemplateKey: eventData.extendedProps.workoutTemplateKey,
            completionData: eventData.extendedProps.completionData
        }

        ShowModal(modalData)

    }

    const ShowWorkoutOverrideModal = () => {

        const modalData = {
            key: ModalKey.WorkoutOverride,
            size: 'third',
            calendarDataKey: eventData.extendedProps.calendarDataKey,
            weekOfTheYearKey: eventData.extendedProps.weekOfTheYearKey,
            workoutTemplateKey: eventData.extendedProps.workoutTemplateKey,
            showStartWorkoutButton: true
        }

        ShowModal(modalData)
    }

    const ShowDeleteWorkoutWarningModal = (event) => {

        event.stopPropagation()
        
        const modalData = {
            key: ModalKey.ActionWarning,
            fullscreen: false,
            size: 'quarter',
            titleText: `Delete ${GetWorkoutTemplateNameFromKey(eventData.extendedProps.workoutTemplateKey)} Workout?`,
            bodyText: [
                'Are you sure you want to delete this workout?',
            ],
            buttonText: 'Delete',
            buttonAction: () => DeleteWorkout(),
        }

        ShowModal(modalData)
    }

    const DeleteWorkout = async () => {

        const jsonBody = {
            userId: eventData.extendedProps.athleteId,
            workoutId: eventData.extendedProps.completionData.completedWorkoutId,
            weekOfTheYearKey: trainingChartPresentWeekOfTheYearKey,
            workoutTemplateKey: eventData.extendedProps.workoutTemplateKey,
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('CORE', 'PATCH', '/archive_workout', jsonBody)

        if (result.data.status == 'failure') {
            console.error(result)
            return;
        }

        const defaultCompletionData = {
            'completed': false,
            'completedWorkoutId': 0,
            'totalVolumeCompleted': 0,
            'totalRepsCompleted': 0
        }

        const payload = {
            workoutTemplateKey: eventData.extendedProps.workoutTemplateKey,
            defaultCompletionData: defaultCompletionData
        }

        // console.log(payload)

        dispatch(setActiveWeekCompletionData(payload))

        // Reload the page to update the calendar

        window.location.reload()
    }

    if (profileType === 'group') {
        return (
            <div 
                onClick={() => OnEventItemClicked()}
            >
                <div className='flex items-center gap-x-0.5'>
                    <img src={kinesisLogo} alt='Kinesis Logo' className='h-4 w-4' />
                    <div className='text-gray-800 text-xxs 2xl:text-xs font-medium whitespace-normal'>{eventData.title}</div>
                </div>

                {/* Setting to past here tiggers for the status to be calculated */}
                <GroupCompletionLinearFill calendarDataKey={'past'} eventData={eventData} />
            </div>
        )
    }

    if (profileType === 'group-individual' || profileType === 'individual') {
        return (
            <div 
                onClick={() => OnEventItemClicked()}
            >
                <div className='flex items-center gap-x-0.5'>
                    <img src={kinesisLogo} alt='Kinesis Logo' className='h-4 w-4' />
                    <div className='text-gray-800 text-xxs 2xl:text-xs font-medium whitespace-normal'>{eventData.title}</div>
                </div>

                {eventData.extendedProps.completionData.completed && 
                    <div className='flex items-center px-0.5'>
                        <div className='flex-grow text-green-500 text-xxs 2xl:text-xs'>Complete</div>

                        <TrashIcon 
                            className='h-3 w-3 text-gray-500 cursor-pointer hover:text-gray-700' 
                            onClick={(event) => ShowDeleteWorkoutWarningModal(event)}
                        />
                    </div>
                }

                {/* For active events, display incomplete workouts in the future as "Scheduled" */}

                {!eventData.extendedProps.completionData.completed &&
                    <>
                        {eventData.extendedProps.isInThePast && <div className='pl-0.5 text-red-500 text-xxs 2xl:text-xs'>Incomplete</div>}
                        {!eventData.extendedProps.isInThePast && <div className='pl-0.5 text-gray-500 text-xxs 2xl:text-xs'>Preview</div>}
                    </>
                }
            </div>
        )
    }
}